import React, { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import Header from '../../includes/Header';
import Footer from '../../includes/Footer';
import { Container, Row, Col } from 'react-bootstrap';
import Loader from '../../components/Loader/Loader';
import { ToastContainer, toast } from 'react-toastify';
import { postProductBrandModel } from '../../apiservices/ApiServices';
import { FaArrowRight, FaMagnifyingGlass } from "react-icons/fa6";

const FindYourModel = () => {
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [data, setData] = useState([]);
    const [brand, setBrand] = useState([]);
    const [brandId, setBrandId] = useState('');
    const [msg, setMsg] = useState('');
    const [ismsg, setisMsg] = useState(false);
    const [searchText, setSearchText] = useState('');

    const { id } = useParams();

    const postProductBrandModels = async (postdata) => {
        try {
            const res = await postProductBrandModel(postdata);
            setData(res.data.data);
            setBrand(res.data.all_brands);
            setLoading(false);
            setisMsg(false);
        } catch (error) {
            setLoading(false);
            setisMsg(true);
            setMsg(error.response?.data?.message || 'Error fetching products');
            setData(error.response?.data?.data || []);
        }
    };

    useEffect(() => {
        setisMsg(false);
        setLoading(true);
        setisMsg(false);

        let postData = {
            plan_slug: id || '',
            search: searchText || '',
            brand_id: brandId,
        };
        postProductBrandModels(postData);
    }, [id])

    const SearchApply = async () => {
        setisMsg(false);
        setLoading(true);
        setisMsg(false);

        let postData = {
            plan_slug: id || '',
            search: searchText || '',
            brand_id: brandId,
        };
        postProductBrandModels(postData);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && searchText.length > 2) {
            SearchApply();
        }
    };



    return (
        <>
            <Header toast={toast} />
            <ToastContainer />

            {isLoading ? (<Loader />) : (
                <div id='FindYourModel'>
                    <section className="Popularbard">
                        <div className="Popularbard-panel">
                            <div className="Popularbard-inner">
                                <div className="eyebrow"><span className="dia">◆</span>Smart Compatibility Tool</div>
                                <h1 className="title">Find Your <span className="accent">Model</span></h1>
                                <p className="sub">Type your phone model and instantly see all compatible products.</p>

                                <div className="search-row">
                                    <label className="search-box">
                                        <FaMagnifyingGlass />
                                        <input
                                            type='search'
                                            value={searchText}
                                            placeholder="e.g. iPhone 15 Pro, Samsung S24, OnePlus 12…" aria-label="Search phone model"
                                            onChange={(e) => setSearchText(e.target.value)}
                                            onKeyPress={handleKeyPress}
                                        />
                                    </label>
                                    <select
                                        className="custom-select"
                                        value={brandId}
                                        onChange={(e) => setBrandId(e.target.value)}
                                    >
                                        <option value="">Select Brand</option>
                                        {brand.map((item) => (
                                            <option key={item.brand_id} value={item.brand_id}>
                                                {item.brand_name}
                                            </option>
                                        ))}
                                    </select>
                                    <button className="find-btn" onClick={SearchApply}>Find Products <FaArrowRight /></button>
                                </div>
                            </div>

                        </div>
                    </section>

                    <section className="popular">
                        <div className="popular-head">
                            <h2>Search your device above</h2>
                            <p>or tap a popular model below to get started</p>
                        </div>
                        <div className="grid">
                            {data?.map((item) => {
                                return (
                                    <Link key={`modal_${item.model_id}`} className="cardnew" to={id ? `/accessories/${item?.brand_id}/${item?.model_id}/${id}` : `/accessories/${item?.brand_id}/${item?.model_id}`}>
                                        <div className="phone">
                                            <img src="https://placehold.co/160x240/1a2530/0a0e13" alt="iPhone 16 Pro" />
                                        </div>
                                        <div className="card-body">
                                            <h3>{item?.model_name}</h3><div className="count">{item?.product_count} products</div>
                                        </div>
                                        <span className="card-arrow"><FaArrowRight /></span>
                                    </Link>
                                );
                            })}
                        </div>
                    </section>
                </div>
            )}
            <Footer toast={toast} />
        </>
    )
}

export default FindYourModel